function getImgBase(): string {
  const v = process.env.NEXT_PUBLIC_IMG_BASE;
  if (!v) throw new Error("NEXT_PUBLIC_IMG_BASE is not set");
  return v.replace(/\/$/, "");
}

export function img(path: string) {
  const base = getImgBase();
  return `${base}/${encodeURI(path.replace(/^\//, ""))}`;
}
